"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT = void 0;
const FAMILY = {
  BODY: 'Visuelt, Helvetica, sans-serif',
  DECORATIVE: 'Arbutus Slab, Adjusted Georgia Fallback, Georgia, serif'
};
const SIZE = {
  XXS: '12px',
  XS: '14px',
  S: '16px',
  M: '18px',
  L: '24px',
  XL: '32px',
  XXL: '40px',
  XXXL: '48px'
};
const WEIGHT = {
  REGULAR: 400,
  MEDIUM: 500,
  BOLD: 700
};
const FONT = exports.FONT = {
  FAMILY,
  SIZE,
  WEIGHT
};